import { useSite } from "@/lib/site-context";

export default function About() {
  const { site } = useSite();
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
      <div className="text-[11px] uppercase tracking-[0.25em] text-[#D9A62E] font-mono-piki font-semibold">About</div>
      <h1 className="mt-3 font-display text-4xl sm:text-5xl font-extrabold text-white">About Piki Car Rentals</h1>
      <p className="mt-6 text-lg text-[#D4D4D4] leading-relaxed">
        {site?.about || "Piki Car Rentals is a locally operated rental company committed to easy, reliable and affordable vehicle rentals."}
      </p>
      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
        {[
          { title: "Our Promise", desc: "Clean vehicles, honest pricing, and straightforward rental terms — every single time." },
          { title: "Locally Operated", desc: "We know the roads and the community we serve. Personal attention on every booking." },
          { title: "Customer First", desc: "Real people are ready to help by phone, WhatsApp or in person. Editable placeholder content." },
        ].map((b, i) => (
          <div key={i} className="piki-card p-6">
            <div className="font-display font-bold text-lg text-white">{b.title}</div>
            <p className="mt-2 text-sm text-[#A3A3A3] leading-relaxed">{b.desc}</p>
          </div>
        ))}
      </div>
      <p className="mt-10 text-xs text-[#737373]">This page is editable from the admin panel — replace this placeholder copy with your real company story.</p>
    </div>
  );
}
